// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/additional_services/remover
 *
 * Soft-deletes an additional service by ID (sets active = 0).
 */
import { registerContract } from './validate'

export interface AdditionalServices_RemoverInput {
so_additional_service_id: number
}

registerContract('AdditionalServices_RemoverInput', {
  so_additional_service_id: { type: 'number',  required: true },
})
